import axios from 'axios'
import { USER_LOGIN, USER_TOKEN, USER, USER_CHANGE_ACCOUNT, USER_AGENDA, USER_CHANGE_PASSWORD } from "./CONSTANTS";

export const login = (model) => {
  console.info("userServices > login called...");
  return new Promise((resolve, reject) => {
      axios
      .post(USER_LOGIN(),model)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const changePassword = (model) => {
  console.info("userServices > login called...");
  return new Promise((resolve, reject) => {
      axios
      .post(USER_CHANGE_PASSWORD(),model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const userChangeAccount = (model) => {
  console.info("userServices > change account called...");
  return new Promise((resolve, reject) => {
      axios
      .post(USER_CHANGE_ACCOUNT(),model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getUserList = (pagination) => {
  console.info("userServices > getUserList...");
  return new Promise((resolve, reject) => {
      axios
      .get(USER(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addUser = (model) => {
  console.info("userServices > addUser...");
  return new Promise((resolve, reject) => {
      axios
      .post(`${USER()}`,model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateUser = (model) => {
  console.info("userServices > updateUser...");
  return new Promise((resolve, reject) => {
      axios
      .put(`${USER()}`,model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteUser = (uniqueKey) => {
  console.info("userServices > deleteUser...");
  return new Promise((resolve, reject) => {
      axios
      .delete(`${USER()}/${uniqueKey}`,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};


export const getUserAgendaList = (starDate,type) => {
  console.info("UserServices > getUserAgendaList...");
  return new Promise((resolve, reject) => {
      axios
      .get(USER_AGENDA()+`?startdate=${starDate}&type=${type}`,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addUserAgenda = (model) => {
  console.info("UserServices > addUserAgenda...");
  return new Promise((resolve, reject) => {
      axios
      .post(`${USER_AGENDA()}`,model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateUserAgenda = (model) => {
  console.info("UserServices > updateUserAgenda...");
  return new Promise((resolve, reject) => {
      axios
      .put(`${USER_AGENDA()}`,model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};


export const deleteUserAgenda = (uniqueKey) => {
  console.info("UserServices > deleteUserAgenda...");
  return new Promise((resolve, reject) => {
      axios
      .delete(`${USER_AGENDA()}/${uniqueKey}`,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
